let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("glWzP"), load("8XFC9")]).then(() => parcelRequire('gnNGp'));